import React from 'react';

function NameHeaderComponent() {
  return (
    <section className='grid'>
      <h1 className='text-colour1 lg:hidden font-hello-paris-medium slide_bottom overflow-hidden dark:text-colour1 text-6xl lg:text-9xl tracking-widest'>
        <div className='text-animation overflow-hidden bg-colour2'>
          Mistress
        </div>
        <div className='text-animation lg:-mt-4 delay overflow-hidden bg-colour2'>
          Diva
        </div>
      </h1>
      <h1 className='text-colour1 hidden lg:inline-block font-hello-paris-medium leading-[-1rem] h-fit overflow-hidden dark:text-colour1 text-6xl lg:text-9xl tracking-widest'>
        <div className='text-animation overflow-hidden bg-colour2'>
          Mistress Diva
        </div>
      </h1>
    </section>
  );
}

export default NameHeaderComponent;
